module.exports = __webpack_public_path__ + "static/media/form-bg.7950635b.jpg";